import { Component, OnInit, Input } from '@angular/core';
import { UserService } from '@app/services/User/user.service';
import { User } from '@app/model/user';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { EmailService } from '@app/services/Email/email.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductService } from '@app/services/Product/product.service';
import { Product } from '@app/model/product';
import { BusinessSliderInfo } from '@app/model/business-slider-info';
import { BusinessDetailsService } from '@app/services/BusinessDetails/businessDetails.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-send-enquiry',
  templateUrl: './send-enquiry.component.html',
  styleUrls: ['./send-enquiry.component.scss']
})
export class SendEnquiryComponent implements OnInit {
  
  enquiryForm!: FormGroup;
  //name!: string;
  //email!: string;
  //phone!: number;
  //message!: string;

  businessUser:any; 
  userInfoId: any;
  productInfoId: any;

  productDetails: any;
  businessSlider:any;

  enquiryPhoto:any;
  productPhoto:any;
  businessPhoto:any;

  urlRouter:any;
  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService, 
    private productService: ProductService,
    private emailService: EmailService, 
    private businessService: BusinessDetailsService,
    private route: ActivatedRoute, 
    router: Router,
    location: Location) 
  { 
    this.businessUser = new User();
    router.events.subscribe(() => { // for home page enquiry form
      if (location.path() != '') {
        this.urlRouter = location.path();
      } else {
        this.urlRouter = '';
      }
    });
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.userInfoId = params['uid'];
      this.productInfoId = params['id']; 
    });

    this.enquiryForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$')])],
      phone: ['', Validators.required],
      message: ['', Validators.compose([Validators.required])],
    }) 

    if (this.userInfoId != null) {
      if (this.userInfoId != null && this.productInfoId != null) {
        this.getBusinessUserById(this.userInfoId);
        this.fetchProductDetailsById(this.productInfoId, this.userInfoId); 
      } else {
        this.getBusinessUserById(this.userInfoId);
        this.fetchSliderProductById(this.userInfoId); 
      }
    }
    
  } 
 
  get name() { return this.enquiryForm.controls['name']; }
  get email() { return this.enquiryForm.controls['email']; }
  get phone() { return this.enquiryForm.controls['phone']; }
  get message() { return this.enquiryForm.controls['message']; }

  onSubmit() {
    if (this.enquiryForm.invalid) {
      Swal.fire("Please fill the form.");
      return;
    }
    
    const { name, email, phone, message} = this.enquiryForm.value;

    if (this.userInfoId != null && this.productInfoId != null) {
      this.enquiryPhoto =this.productPhoto;
    } else {
      this.enquiryPhoto =this.businessPhoto;
    }
    
    if (this.urlRouter === '') {//TODO
      this.userInfoId = localStorage.getItem('bId'); // this for model
      this.fetchSliderProductById(this.userInfoId); 
      this.getBusinessUserById(this.userInfoId); //TODO
    }
    // else {
    //  this.getBusinessUserById(this.userInfoId); // required list other TODO
    //}

    const businessEmail = this.businessUser.user_name;
    if(businessEmail != null){
      this.emailService.sendEmail(this.userInfoId, this.productInfoId, businessEmail, name, email, phone, message, this.enquiryPhoto).subscribe({
        next: (response: any) => {
          this.enquiryForm.reset();
          if (response) {
            Swal.fire({
              title: response.message,
              icon: "success",
              showConfirmButton: false,
              timer: 2000
            });
          }
          else {
            Swal.fire({
              title: response.message,
              icon: "error",
              showConfirmButton: false,
              timer: 2000
            });
          }
        },
        error: (error: any) => {
          Swal.fire({
            title: 'Technical Issue, Try again',
            icon: "error",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    } else {
      Swal.fire("Technical Issue, Try again!")
    }
  }

  async getBusinessUserById(userInfoId:any){
    await this.userService.getById(userInfoId).subscribe({
      next: (p) => {
        this.businessUser = p as User;
          if (this.businessUser.data != null && this.businessUser.data.length > 0) {
            this.businessUser.user_name = this.businessUser.data[0].userName;
          }
      }
    })
  }
  
  async fetchSliderProductById(userInfoId:any) {
    await this.businessService.getSliderImageByUUId(userInfoId)
      .subscribe({
        next: (p) => {
          this.businessSlider = p as BusinessSliderInfo;
          if (this.businessSlider.data != null && this.businessSlider.data.length > 0) {
            this.businessPhoto = this.businessSlider.data[0].businessImageURL;
          }
          else {
            this.businessPhoto = 'no-image.jpg';
          }
        }
      });
  }
  
  async fetchProductDetailsById(productInfoId:any, userInfoId:any) {
    await this.productService.getSellerProductByUUID_Id(productInfoId, userInfoId)
      .subscribe({
        next: (p) => {
          this.productDetails = p as Product;
          if (this.productDetails.data != null && this.productDetails.data.length > 0) {
            this.productPhoto = this.productDetails.data[0].sellProductImageURL;
          }
          else {
            this.productPhoto = 'no-image.jpg';
          }
        } 
      });
  }
}
